import React, { useState } from 'react';
import api from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Loader2, BellRing, Check } from 'lucide-react';
import { toast } from 'sonner';

const daysAgo = (iso) => {
  if (!iso) return null;
  const d = Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
  return d <= 0 ? 'today' : d === 1 ? 'yesterday' : `${d} days ago`;
};

/** One-click nudge for a family that still owes feedback. */
export default function FeedbackReminderButton({ booking, onSent, size = 'sm' }) {
  const [sending, setSending] = useState(false);
  const [sentAt, setSentAt] = useState(booking.feedback_reminder_sent_at || null);
  const when = daysAgo(sentAt);
  const justToday = when === 'today';

  const send = async (e) => {
    e?.stopPropagation();
    setSending(true);
    try {
      const r = await api.post(`/coordinator/bookings/${booking.id}/feedback-reminder`);
      setSentAt(r.data?.feedback_reminder_sent_at || new Date().toISOString());
      toast.success(`Reminder sent to ${booking.parent_name || 'the family'}`);
      onSent?.();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Could not send the reminder');
    }
    setSending(false);
  };

  return (
    <Button size={size} variant="outline" onClick={send} disabled={sending || justToday}
      className="rounded-lg text-[11px] h-7 px-2 border-gray-200 hover:border-[#F97D6A] hover:text-[#F97D6A] disabled:opacity-60"
      data-testid={`remind-feedback-${booking.id}`}>
      {sending ? <Loader2 className="h-3 w-3 mr-1 animate-spin" />
        : justToday ? <Check className="h-3 w-3 mr-1" />
          : <BellRing className="h-3 w-3 mr-1" />}
      {justToday ? 'Reminded today' : when ? `Remind again · ${when}` : 'Send reminder'}
    </Button>
  );
}
